/* eslint-disable camelcase */
import meta from './global/meta.js'
import app from './global/app.js'
import login from './global/login.js'
import user from './global/user.js'
import theme from './global/theme.js'
import confirm from './global/confirm.js'
import snackbar from './global/snackbar.js'
import notifications from './global/notifications.js'
import global from './global/global.js'
import utils from './global/utils.js'

import orders from './pages/orders.js'
import scheduler from './pages/scheduler.js'
import categories from './pages/categories.js'
import catalog from './pages/catalog.js'
import services from './pages/services.js'
import items from './pages/items.js'
import additional from './pages/additional.js'
import customers from './pages/customers.js'
import historic from './pages/historic.js'
import financial from './pages/financial.js'
import users from './pages/users.js'
import config from './pages/config.js'
import permissions from './pages/permissions.js'

let language = {
  /* GLOBAL */
  meta,
  app,
  login,
  user,
  theme,
  confirm,
  snackbar,
  notifications,
  global,
  utils,
  /* PAGES */
  orders,
  scheduler,
  categories,
  catalog,
  services,
  items,
  additional,
  customers,
  historic,
  financial,
  users,
  config,
  permissions
  /* */
}

export default language
